import React, { useMemo } from 'react';

import { Box, Code, Flex, Text } from '@chakra-ui/react';

import { ApiFieldValues } from './ApiFieldValues';
import { ApiSchema } from './types';
import { schemaFields, schemaTypeLabel } from './utils';

/** A schema's fields as an indented list: name, type, required, details. */
export const ApiSchemaFields = ({ schema }: { schema?: ApiSchema }) => {
  const fields = useMemo(() => schemaFields(schema), [schema]);
  if (!schema) return null;
  if (!fields.length)
    return (
      <Text fontSize="15px" color="gray.600">
        Returns <Code fontSize="13px">{schemaTypeLabel(schema)}</Code>.
      </Text>
    );
  return (
    <Box border="1px solid" borderColor="gray.200" borderRadius="md">
      {fields.map((field, index) => (
        <Box
          key={`${index}-${field.name}`}
          px={4}
          py={2.5}
          pl={4 + field.depth * 5}
          borderTop={index ? '1px solid' : undefined}
          borderColor="gray.100"
        >
          <Flex gap={2} align="baseline" wrap="wrap">
            <Code fontSize="13px" bg="transparent" p={0} fontWeight={600}>
              {field.name}
            </Code>
            <Text fontSize="13px" color="gray.500">
              {field.type}
            </Text>
            {field.required && (
              <Text fontSize="12px" color="red.500">
                required
              </Text>
            )}
          </Flex>
          {field.description && field.description !== field.name && (
            <Text fontSize="14px" color="gray.700" mt={0.5}>
              {field.description}
            </Text>
          )}
          {field.values && <ApiFieldValues values={field.values} />}
        </Box>
      ))}
    </Box>
  );
};
